(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["motl-epic"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('motl-atlas')) {
 customElements.define('motl-atlas', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   this.abort = new AbortController();
   const signal = this.abort.signal;

   this.querySelectorAll('[data-mural-player]').forEach(player => {
    const video = player.querySelector('video'), play = player.querySelector('[data-mural-play]'), error = player.querySelector('[data-mural-error]');
    if (!video || !play) return;
    play.hidden = false;
    play.addEventListener('click', async () => {
     error.hidden = true; play.hidden = true;
     try { await video.play(); video.focus({preventScroll:true}); }
     catch { play.hidden = false; error.hidden = false; }
    }, {signal});
    video.addEventListener('play', () => { play.hidden = true; error.hidden = true; }, {signal});
    video.addEventListener('ended', () => { play.hidden = false; }, {signal});
    video.addEventListener('error', () => { error.hidden = false; play.hidden = false; }, {signal});
    document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); }, {signal});
   });


   const hero = this.querySelector('[data-cinematic-hero]'), heroMotion = this.querySelector('[data-hero-motion]');
   const motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
   let heroPaused = false, heroVisibleForMotion = true;
   const updateHeroMotion = () => {
    const stopped = heroPaused || motionPreference.matches;
    hero.classList.toggle('is-motion-paused', stopped || !heroVisibleForMotion || document.hidden);
    heroMotion.hidden = motionPreference.matches;
    heroMotion.setAttribute('aria-pressed', String(stopped));
    heroMotion.setAttribute('aria-label', stopped ? heroMotion.dataset.playLabel : heroMotion.dataset.pauseLabel);
    heroMotion.firstElementChild.textContent = stopped ? '▶' : 'Ⅱ';
   };
   heroMotion.addEventListener('click', () => { heroPaused = !heroPaused; updateHeroMotion(); }, {signal});
   motionPreference.addEventListener('change', updateHeroMotion, {signal});
   document.addEventListener('visibilitychange', updateHeroMotion, {signal});
   this.heroMotionObserver = new IntersectionObserver(entries => { heroVisibleForMotion = entries[0].isIntersecting; updateHeroMotion(); });
   this.heroMotionObserver.observe(hero); updateHeroMotion();


   const counters = [...this.querySelectorAll('[data-count-to]')];
   const counterFinal = counters.map(el => el.textContent);
   const numberFormat = new Intl.NumberFormat(document.documentElement.lang || 'en');
   let counted = false;
   const finishCounts = () => { cancelAnimationFrame(this.countFrame); counters.forEach((el,i) => el.textContent = counterFinal[i]); };
   this.finishCounts = finishCounts;
   const countUp = () => {
    if (counted) return; counted = true; this.countObserver?.disconnect();
    if (motionPreference.matches) { finishCounts(); return; }
    const started = performance.now();
    const tick = now => {
     const progress = Math.min(1, (now - started) / 1400), eased = 1 - Math.pow(1 - progress, 3);
     counters.forEach(el => { el.textContent = numberFormat.format(Math.floor(Number(el.dataset.countTo) * eased)) + el.dataset.countSuffix; });
     if (progress < 1) this.countFrame = requestAnimationFrame(tick); else finishCounts();
    };
    this.countFrame = requestAnimationFrame(tick);
   };
   this.countObserver = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) countUp(); }, {threshold:.4});
   this.countObserver.observe(this.querySelector('.mla-stats'));
   motionPreference.addEventListener('change', () => { if (motionPreference.matches) { counted = true; this.countObserver.disconnect(); finishCounts(); } }, {signal});

   const animations = Array.from(this.querySelectorAll('.mla-animation'));
   const motion = this.querySelector('[data-motion]');
   let paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
   const updateMotion = () => { motion.textContent = paused ? this.dataset.play : this.dataset.pause; motion.setAttribute('aria-pressed', String(paused)); animations.forEach(v => { if (paused) v.pause(); else if (v.dataset.visible === 'true') v.play().catch(() => {}); }); };
   if (animations.length) {
    motion.hidden = false;
    updateMotion();
    this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => { entry.target.dataset.visible = String(entry.isIntersecting); if (entry.isIntersecting && !paused) entry.target.play().catch(() => {}); else entry.target.pause(); }), {threshold:.2});
    animations.forEach(v => this.videoObserver.observe(v));
    motion.addEventListener('click', () => { paused = !paused; updateMotion(); }, {signal});
   }

  }
  disconnectedCallback() { this.countObserver?.disconnect(); this.finishCounts?.(); this.abort?.abort(); this.heroMotionObserver?.disconnect(); this.videoObserver?.disconnect(); this.dockObserver?.disconnect(); this.initialized = false; }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-world-landing"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('world-landing')) {
    customElements.define('world-landing', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready !== 'true') {
          this.dataset.ready = 'true';
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.refreshObserver = new MutationObserver(records => {
            if (records.every(record => record.target.closest?.('titan-map-explorer, titan-lp-ui'))) return;
            if (this.refreshQueued) return;
            this.refreshQueued = true;
            requestAnimationFrame(() => { this.refreshQueued = false; this.initialize(); });
          });
          this.refreshObserver.observe(this, { childList: true, subtree: true });
        }
        this.initialize();
      }
      initialize() {
        
        this.setupCounters();
        
        this.setupAtlas();
        this.setupCompare();
        this.setupScale();
        
        this.setupAmbient();
        this.setupVoyage();
      }
      setupCounters() {
        const counters = [...this.querySelectorAll('[data-count]')].filter((counter) => counter.dataset.worldCounterBound !== 'true');
        counters.forEach((counter) => { counter.dataset.worldCounterBound = 'true'; });
        if (this.reduceMotion || !('IntersectionObserver' in window)) return;
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          const target = Number(entry.target.dataset.count);
          const start = performance.now();
          const tick = (now) => { const progress = Math.min((now - start) / 1500, 1); entry.target.textContent = Math.round(target * (1 - Math.pow(1 - progress, 3))).toLocaleString(); if (progress < 1) requestAnimationFrame(tick); };
          requestAnimationFrame(tick);
        }), { threshold: .7 });
        counters.forEach((counter) => observer.observe(counter));
      }
      setupAtlas() {
        const atlas = this.querySelector('[data-world-atlas]');
        if (!atlas || atlas.dataset.worldBound === 'true') return;
        atlas.dataset.worldBound = 'true';
        const nav = atlas.querySelector('.world-lp__atlas-nav');
        const tabs = [...atlas.querySelectorAll('[data-atlas-tab]')];
        const panels = [...atlas.querySelectorAll('[data-atlas-panel]')];
        const duration = 4200;
        let current = 0;
        let timer;
        let touched = false;
        const animateTick = (on) => {
          atlas.querySelectorAll('[data-atlas-tick]').forEach((tick) => tick.classList.remove('is-running'));
          const tick = panels[current]?.querySelector('[data-atlas-tick]');
          if (!tick) return;
          tick.firstElementChild.style.animationDuration = `${duration}ms`;
          void tick.offsetWidth;
          if (on) tick.classList.add('is-running');
        };
        const show = (index) => {
          current = (index + panels.length) % panels.length;
          tabs.forEach((tab, itemIndex) => tab.setAttribute('aria-selected', String(itemIndex === current)));
          panels.forEach((panel, itemIndex) => {
            const active = itemIndex === current;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          });
          if (nav && window.matchMedia('(max-width: 939px)').matches) {
            const item = tabs[current]?.parentElement;
            if (item) requestAnimationFrame(() => nav.scrollTo({ left: item.offsetLeft, behavior: 'smooth' }));
          }
        };
        const stop = () => { if (timer) clearInterval(timer); timer = undefined; animateTick(false); };
        const start = () => {
          if (this.reduceMotion || touched || timer || tabs.length < 2) return;
          animateTick(true);
          timer = setInterval(() => { show(current + 1); animateTick(true); }, duration);
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('mouseenter', () => { if (!touched) { show(index); if (timer) animateTick(true); } });
          tab.addEventListener('click', () => { touched = true; stop(); show(index); });
        });
        show(0);
        if (!this.reduceMotion && 'IntersectionObserver' in window) {
          new IntersectionObserver(([entry]) => { if (entry.isIntersecting) start(); else stop(); }, { threshold: .35 }).observe(atlas);
        }
      }
      setupCompare() {
        const compare = this.querySelector('[data-world-compare]');
        if (!compare || compare.dataset.worldBound === 'true') return;
        compare.dataset.worldBound = 'true';
        const tabs = compare.querySelectorAll('[data-compare-tab]');
        const panels = compare.querySelectorAll('[data-compare-panel]');
        const show = (tab, focus = false) => {
          const index = tab.dataset.compareTab;
          tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
          });
          panels.forEach((panel) => {
            const selected = panel.dataset.comparePanel === index;
            panel.hidden = !selected;
            panel.classList.toggle('is-active', selected);
          });
          if (focus) tab.focus();

        };
        tabs.forEach((tab, index) => {
          tab.tabIndex = index === 0 ? 0 : -1;
          tab.addEventListener('click', () => show(tab));
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let next = index;
            if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            show(tabs[next], true);
          });
        });
        if ('IntersectionObserver' in window) {
          const preloadObserver = new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) return;
            preloadObserver.disconnect();
            compare.querySelectorAll('img[loading="lazy"]').forEach((image) => { image.loading = 'eager'; });
          }, { rootMargin: '600px 0px' });
          preloadObserver.observe(compare);
        }

      }
      setupScale() {
        const widget = this.querySelector('[data-world-scale]');
        if (!widget || widget.dataset.worldBound === 'true') return;
        widget.dataset.worldBound = 'true';
        const tabs = [...widget.querySelectorAll('[data-scale-tab]')];
        const images = [...widget.querySelectorAll('[data-scale-image]')];
        const tick = widget.querySelector('[data-scale-tick]');
        const duration = 4600;
        let current = 0;
        let timer;
        let touched = false;
        const animateTick = (on) => {
          if (!tick) return;
          tick.classList.remove('is-running');
          tick.firstElementChild.style.animationDuration = `${duration}ms`;
          void tick.offsetWidth;
          if (on) tick.classList.add('is-running');
        };
        const show = (index) => {
          current = (index + images.length) % images.length;
          tabs.forEach((tab, itemIndex) => tab.setAttribute('aria-selected', String(itemIndex === current)));
          images.forEach((image, itemIndex) => image.classList.toggle('is-active', itemIndex === current));
        };
        const stop = () => { if (timer) clearInterval(timer); timer = undefined; animateTick(false); };
        const start = () => {
          if (this.reduceMotion || touched || timer || images.length < 2) return;
          animateTick(true);
          timer = setInterval(() => { show(current + 1); animateTick(true); }, duration);
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('mouseenter', () => { show(index); if (timer) animateTick(true); });
          tab.addEventListener('click', () => { touched = true; stop(); show(index); });
        });
        show(0);
        if (!this.reduceMotion && 'IntersectionObserver' in window) {
          new IntersectionObserver(([entry]) => { if (entry.isIntersecting) start(); else stop(); }, { threshold: .2 }).observe(widget);
        } else if (!this.reduceMotion) start();
      }
      setupAmbient() {
        const ambients = [...this.querySelectorAll('.world-lp__ambient')].filter((ambient) => ambient.dataset.worldAmbientBound !== 'true');
        if (!ambients.length || this.reduceMotion) return;
        ambients.forEach((ambient) => { ambient.dataset.worldAmbientBound = 'true'; });
        let queued = false;
        const move = () => {
          queued = false;
          const viewportCenter = window.innerHeight / 2;
          ambients.forEach((ambient) => {
            const rect = ambient.parentElement.getBoundingClientRect();
            const offset = rect.top + rect.height / 2 - viewportCenter;
            const shift = Math.max(-58, Math.min(58, -offset * .06));
            ambient.style.setProperty('--world-parallax-y', `${shift}px`);
          });
        };
        const requestMove = () => { if (!queued) { queued = true; requestAnimationFrame(move); } };
        window.addEventListener('scroll', requestMove, { passive: true });
        window.addEventListener('resize', requestMove);
        move();
      }
      setupVoyage() {
        const voyage = this.querySelector('[data-world-voyage]');
        const ship = voyage?.querySelector('[data-world-ship]');
        if (!voyage || !ship || voyage.dataset.worldBound === 'true' || this.reduceMotion) return;
        voyage.dataset.worldBound = 'true';
        let queued = false;
        const sail = () => { queued = false; const rect = this.getBoundingClientRect(); const total = Math.max(this.scrollHeight - window.innerHeight, 1); const progress = Math.max(0, Math.min(1, -rect.top / total)); const travel = Math.max(voyage.clientHeight - 56, 0); ship.style.transform = `translateY(${12 + progress * travel}px)`; };
        const queueSail = () => { if (!queued) { queued = true; requestAnimationFrame(sail); } };
        window.addEventListener('scroll', queueSail, { passive: true }); window.addEventListener('resize', queueSail, { passive: true }); sail();
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woe-epic-26d7"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('woe-epic-experience'))customElements.define('woe-epic-experience',class extends HTMLElement{
 connectedCallback(){
  if(this.initialized)return;this.initialized=true;
  const start=()=>{if(!this.isConnected)return;this.abort=new AbortController();const on=(el,type,fn,opt={})=>el?.addEventListener(type,fn,{...opt,signal:this.abort.signal});const q=s=>this.querySelector(s),qa=s=>[...this.querySelectorAll(s)];
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const track=(action,data={})=>{this.dispatchEvent(new CustomEvent('woe:interaction',{bubbles:true,detail:{action,...data}}));try{window.Shopify?.analytics?.publish?.('woe_landing_interaction',{action,...data});}catch(e){}};
  qa('[data-purchase]').forEach(a=>on(a,'click',()=>track('purchase_click',{format:a.dataset.purchase,placement:a.closest('.we-hero')?'hero':a.closest('.we-sticky')?'sticky':'content'})));
  qa('[data-discovery]').forEach(b=>on(b,'click',()=>{qa('[data-discovery]').forEach(x=>x.setAttribute('aria-expanded',String(x===b)));qa('.we-discovery-panel').forEach(p=>{p.hidden=p.id!==b.getAttribute('aria-controls');if(!p.hidden&&!reduce){p.classList.remove('we-reveal');void p.offsetWidth;p.classList.add('we-reveal');}});track('discovery',{topic:b.dataset.discovery});}));
  const sticky=q('[data-sticky]');let heroVisible=true,formatsVisible=false,endVisible=false;
  this.visibility=new IntersectionObserver(es=>{es.forEach(e=>{if(e.target.matches('.we-hero'))heroVisible=e.isIntersecting;if(e.target.matches('.we-formats'))formatsVisible=e.isIntersecting;if(e.target.matches('.we-end'))endVisible=e.isIntersecting;});sticky.hidden=heroVisible||formatsVisible||endVisible;});['.we-hero','.we-formats','.we-end'].forEach(s=>this.visibility.observe(q(s)));
  qa('video').forEach(v=>on(v,'play',()=>{qa('video').filter(x=>x!==v).forEach(x=>x.pause());track('video_play');}));
  const viewer=q('[data-viewer]'),view=q('[data-viewport]'),stage=q('[data-stage]'),preview=q('.we-preview'),tiles=q('[data-tiles]'),activate=q('[data-activate]'),done=q('[data-done]'),fullButton=q('[data-fullscreen]'),quality=q('[data-quality]');
  let active=false,full=false,z=1,x=0,y=0,w=2160,h=1260,fw=1,fh=1,dzi=null,loading=false,frame=0,lastFocus=null,oldOverflow='',pinch=null,drag=null;
  const pointers=new Map(),cache=new Map(),originalQuality=quality.textContent,clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  const maxZoom=()=>dzi?Math.min(40,Math.max(8,dzi.width/fw)):6;
  const renderTiles=()=>{
   if(!dzi||fw<=0)return;
   const level=clamp(Math.ceil(Math.log2(Math.max(fw*z,fh*z)*(window.devicePixelRatio||1))),0,dzi.max),down=2**(dzi.max-level),lw=Math.ceil(w/down),lh=Math.ceil(h/down),ts=dzi.tile;
   const sx=(view.clientWidth-fw*z)/2+x,sy=(view.clientHeight-fh*z)/2+y;
   const c0=clamp(Math.floor(-sx/(fw*z)*lw/ts),0,Math.ceil(lw/ts)-1),c1=clamp(Math.floor((view.clientWidth-sx)/(fw*z)*lw/ts),0,Math.ceil(lw/ts)-1),r0=clamp(Math.floor(-sy/(fh*z)*lh/ts),0,Math.ceil(lh/ts)-1),r1=clamp(Math.floor((view.clientHeight-sy)/(fh*z)*lh/ts),0,Math.ceil(lh/ts)-1),visible=new Set();
   for(let row=r0;row<=r1;row++)for(let col=c0;col<=c1;col++){const key=`${level}/${col}_${row}`;visible.add(key);let im=cache.get(key);if(!im){const left=Math.max(0,col*ts-dzi.overlap),top=Math.max(0,row*ts-dzi.overlap),right=Math.min(lw,(col+1)*ts+dzi.overlap),bottom=Math.min(lh,(row+1)*ts+dzi.overlap);im=new Image();im.alt='';im.draggable=false;im.decoding='async';im.style.cssText=`left:${left/lw*100}%;top:${top/lh*100}%;width:${(right-left)/lw*100}%;height:${(bottom-top)/lh*100}%;`;im.addEventListener('error',()=>{im.remove();cache.delete(key);quality.textContent=originalQuality;},{once:true});im.src=`${dzi.base}/${key}.${dzi.format}`;cache.set(key,im);tiles.append(im);}im.hidden=false;}
   for(const[key,im]of cache)if(!visible.has(key)){im.hidden=true;if(cache.size>100){im.remove();cache.delete(key);}}
  };
  const render=()=>{fw=Math.min(view.clientWidth,view.clientHeight*w/h);fh=fw*h/w;x=clamp(x,-Math.max(0,(fw*z-view.clientWidth)/2),Math.max(0,(fw*z-view.clientWidth)/2));y=clamp(y,-Math.max(0,(fh*z-view.clientHeight)/2),Math.max(0,(fh*z-view.clientHeight)/2));stage.style.width=fw+'px';stage.style.height=fh+'px';stage.style.transform=`translate(${(view.clientWidth-fw*z)/2+x}px,${(view.clientHeight-fh*z)/2+y}px) scale(${z})`;q('[data-zoom-label]').textContent=z.toFixed(1).replace('.0','')+'×';if(dzi){cancelAnimationFrame(frame);frame=requestAnimationFrame(renderTiles);}};
  const load=async()=>{if(!viewer.dataset.source||loading||dzi)return;loading=true;try{const resp=await fetch(viewer.dataset.source,{signal:this.abort.signal});if(!resp.ok)throw Error();const xml=new DOMParser().parseFromString(await resp.text(),'application/xml'),im=xml.getElementsByTagName('Image')[0],sz=xml.getElementsByTagName('Size')[0];if(!im||!sz)throw Error();const dw=+sz.getAttribute('Width'),dh=+sz.getAttribute('Height'),ts=+im.getAttribute('TileSize');if(!(dw>0&&dh>0&&ts>0))throw Error();w=dw;h=dh;dzi={width:w,height:h,tile:ts,overlap:+im.getAttribute('Overlap')||0,format:im.getAttribute('Format')||'jpg',max:Math.ceil(Math.log2(Math.max(w,h))),base:new URL(viewer.dataset.source,location.href).href.split('?')[0].replace(/\.dzi$/i,'_files')};quality.textContent=viewer.dataset.detailLabel||originalQuality;render();}catch(e){quality.textContent=originalQuality;}finally{loading=false;}};
  const enable=()=>{if(!active){active=true;activate.hidden=true;done.hidden=false;view.classList.add('is-active');track('explorer_activate');if(!dzi){preview.removeAttribute('srcset');preview.removeAttribute('sizes');preview.src=preview.src.replace(/([?&])width=\d+/,'$1width=2160');}}load();};
  const disable=()=>{active=false;activate.hidden=false;done.hidden=true;view.classList.remove('is-active','is-dragging');pointers.clear();drag=pinch=null;};
  const scale=(next,px=view.clientWidth/2,py=view.clientHeight/2)=>{enable();const nz=clamp(next,1,maxZoom()),ratio=nz/z;x=(x-px+view.clientWidth/2)*ratio+px-view.clientWidth/2;y=(y-py+view.clientHeight/2)*ratio+py-view.clientHeight/2;z=nz;render();};
  const fullscreen=()=>{full=!full;viewer.classList.toggle('is-fullscreen',full);fullButton.setAttribute('aria-pressed',String(full));if(full){lastFocus=document.activeElement;oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';viewer.setAttribute('role','dialog');viewer.setAttribute('aria-modal','true');viewer.setAttribute('aria-label',view.getAttribute('aria-label'));enable();fullButton.focus();}else{document.body.style.overflow=oldOverflow;viewer.removeAttribute('role');viewer.removeAttribute('aria-modal');viewer.removeAttribute('aria-label');lastFocus?.focus({preventScroll:true});}render();};
  on(fullButton,'click',fullscreen);on(activate,'click',()=>{enable();view.focus({preventScroll:true});});on(done,'click',()=>{if(full)fullscreen();disable();activate.focus({preventScroll:true});});
  qa('[data-zoom]').forEach(b=>on(b,'click',()=>scale(z*(b.dataset.zoom==='in'?1.5:1/1.5))));on(q('[data-reset]'),'click',()=>{z=1;x=y=0;render();});
  on(document,'keydown',e=>{if(full&&e.key==='Escape'){e.preventDefault();fullscreen();return;}if(full&&e.key==='Tab'){const els=[view,...viewer.querySelectorAll('button:not([hidden])')].filter(el=>el.offsetParent!==null),first=els[0],last=els[els.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}});
  on(view,'keydown',e=>{if(!active)return;if(['+','=','-','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','Escape'].includes(e.key)){e.preventDefault();if(e.key==='+'||e.key==='=')scale(z*1.3);if(e.key==='-')scale(z/1.3);if(e.key==='ArrowLeft')x+=60;if(e.key==='ArrowRight')x-=60;if(e.key==='ArrowUp')y+=60;if(e.key==='ArrowDown')y-=60;if(e.key==='Home'){z=1;x=y=0;}if(e.key==='Escape'&&!full)disable();render();}});
  on(view,'wheel',e=>{if(!active)return;e.preventDefault();const r=view.getBoundingClientRect();scale(z*Math.exp(-e.deltaY*.0018),e.clientX-r.left,e.clientY-r.top);},{passive:false});
  on(view,'pointerdown',e=>{if(!active||e.button>0)return;view.setPointerCapture(e.pointerId);pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});drag={x:e.clientX,y:e.clientY,ox:x,oy:y};view.classList.add('is-dragging');if(pointers.size===2){const[a,b]=[...pointers.values()],r=view.getBoundingClientRect();pinch={distance:Math.hypot(a.x-b.x,a.y-b.y),z,x,y,mx:(a.x+b.x)/2-r.left-view.clientWidth/2,my:(a.y+b.y)/2-r.top-view.clientHeight/2};}});
  on(view,'pointermove',e=>{if(!pointers.has(e.pointerId))return;pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});if(pointers.size===2&&pinch){const[a,b]=[...pointers.values()],r=view.getBoundingClientRect(),nz=clamp(pinch.z*Math.hypot(a.x-b.x,a.y-b.y)/Math.max(1,pinch.distance),1,maxZoom());x=(pinch.x-pinch.mx)*nz/pinch.z+(a.x+b.x)/2-r.left-view.clientWidth/2;y=(pinch.y-pinch.my)*nz/pinch.z+(a.y+b.y)/2-r.top-view.clientHeight/2;z=nz;}else if(drag){x=drag.ox+e.clientX-drag.x;y=drag.oy+e.clientY-drag.y;}render();});
  const end=e=>{pointers.delete(e.pointerId);pinch=null;if(pointers.size===1){const p=[...pointers.values()][0];drag={x:p.x,y:p.y,ox:x,oy:y};}else{drag=null;view.classList.remove('is-dragging');}};['pointerup','pointercancel','lostpointercapture'].forEach(ev=>on(view,ev,end));
  qa('[data-focus]').forEach(b=>on(b,'click',()=>{enable();const[nx,ny,nz]=b.dataset.focus.split(',').map(Number);z=nz;x=(.5-nx)*fw*z;y=(.5-ny)*fh*z;render();viewer.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});view.focus({preventScroll:true});}));
  this.resize=new ResizeObserver(render);this.resize.observe(view);on(preview,'load',()=>{if(!dzi&&preview.naturalWidth){w=preview.naturalWidth;h=preview.naturalHeight;}render();});render();this.cleanup=()=>{cancelAnimationFrame(frame);if(full)document.body.style.overflow=oldOverflow;};
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 }
 disconnectedCallback(){this.abort?.abort();this.visibility?.disconnect();this.resize?.disconnect();this.cleanup?.();this.initialized=false;}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woe-epic"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('woe-experience')) {
 customElements.define('woe-experience', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   this.cleanups = [];
   this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
   requestAnimationFrame(() => {      this.setupVideos(); this.setupHeroMotion();  this.setupTracking(); });
  }
  track(action, detail = {}) {
   const payload = { project: 'world_of_elements', version: 'epic_v1', action, ...detail };
   try { window.Shopify?.analytics?.publish?.('woe_landing_interaction', payload); } catch (error) {}
   this.dispatchEvent(new CustomEvent('woe:interaction', { bubbles: true, detail: payload }));
  }
  setupVideos() {
   const videos = [...this.querySelectorAll('video:not([data-hero-film])')];
   this.querySelectorAll('[data-woe-player]').forEach(player => {
    const video = player.querySelector('video'), button = player.querySelector('[data-player-toggle]');
    if (!video || !button) return;
    const play = button.querySelector('[data-play-icon]'), pause = button.querySelector('[data-pause-icon]'), error = button.querySelector('[data-player-error]');
    player.dataset.enhanced = 'true'; button.hidden = false;
    customElements.whenDefined('video-media').then(() => player.removeEventListener('click', player.play));
    const sync = () => {
     player.classList.toggle('is-playing', !video.paused);
     player.toggleAttribute('playing', !video.paused);
     button.setAttribute('aria-label', video.paused ? player.dataset.playLabel : player.dataset.pauseLabel);
     play.toggleAttribute('hidden', !video.paused); pause.toggleAttribute('hidden', video.paused);
    };
    button.addEventListener('click', async event => {
     event.stopPropagation(); error.hidden = true;
     if (!video.paused) { video.pause(); return; }
     button.disabled = true;
     videos.forEach(other => { if (other !== video) other.pause(); });
     this.querySelector('[data-hero-film]')?.pause();
     try { await video.play(); } catch (failure) { error.hidden = false; }
     finally { button.disabled = false; sync(); }
    });
    video.addEventListener('play', () => { player.classList.add('has-started'); player.setAttribute('loaded',''); sync(); });
    video.addEventListener('pause', sync); video.addEventListener('ended', sync);
   });
   videos.forEach(video => video.addEventListener('play', () => { videos.forEach(other => { if (other !== video) other.pause(); }); this.querySelector('[data-hero-film]')?.pause(); this.track('video_play'); }));
   const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); }), {threshold:.1});
   videos.forEach(video => observer.observe(video));
   const visibility = () => { if (document.hidden) videos.forEach(video => video.pause()); };
   document.addEventListener('visibilitychange', visibility);
   this.cleanups.push(() => { observer.disconnect(); document.removeEventListener('visibilitychange', visibility); videos.forEach(video => video.pause()); });
  }

  setupHeroMotion() {
   this.querySelectorAll('.woe-hero--fullscreen').forEach(hero => {
   const button = hero.querySelector('[data-hero-motion-toggle]');
   if (!button) return;
   const motion = matchMedia('(prefers-reduced-motion: reduce)');
   let paused = motion.matches, visible = true;
   const sync = () => {
    hero.classList.toggle('is-motion-paused', paused || !visible || document.hidden || motion.matches);
    button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    button.querySelector('[data-motion-play]').toggleAttribute('hidden', !paused);
    button.querySelector('[data-motion-pause]').toggleAttribute('hidden', paused);
    button.hidden = motion.matches;
   };
   const toggle = () => { paused = !paused; sync(); };
   const preference = () => { paused = motion.matches; sync(); };
   const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold:0});
   observer.observe(hero); button.addEventListener('click', toggle);
   motion.addEventListener('change', preference); document.addEventListener('visibilitychange', sync); sync();
   this.cleanups.push(() => { observer.disconnect(); button.removeEventListener('click', toggle); motion.removeEventListener('change', preference); document.removeEventListener('visibilitychange', sync); });
   });
  }
  setupTracking() {
   this.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link?.getAttribute('href')?.includes('/products/')) this.track('product_click', { format: link.getAttribute('href').includes('mural') ? 'mural' : 'poster', position: link.closest('section')?.className || 'dock' });
   });
  }
  disconnectedCallback() { this.cleanups?.forEach(fn => fn()); }
 });
}



if (!customElements.get('woe-video-carousel')) customElements.define('woe-video-carousel', class extends HTMLElement {
 connectedCallback() {
  if (this.controller) return;
  this.controller = new AbortController(); const {signal} = this.controller;
  const track = this.querySelector('.woe-video-carousel');
  const cards = [...track.querySelectorAll('.woe-voice')];
  const prev = this.querySelector('[data-voice-prev]'), next = this.querySelector('[data-voice-next]'), progress = this.querySelector('[data-voice-progress]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)'), rtl = getComputedStyle(track).direction === 'rtl';
  const position = () => Math.abs(track.scrollLeft);
  const maximum = () => Math.max(0,track.scrollWidth-track.clientWidth);
  const update = () => {
   this.frame = 0; const max = maximum(), left = position();
   prev.disabled = max < 2 || left < 2; next.disabled = max < 2 || left >= max-2;
   progress.style.transform = `scaleX(${track.scrollWidth ? Math.min(1,(left+track.clientWidth)/track.scrollWidth) : 1})`;
   progress.style.transformOrigin = rtl ? 'right' : 'left';
  };
  const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(update); };
  const move = left => track.scrollTo({left:(rtl?-1:1)*Math.max(0,Math.min(maximum(),left)),behavior:reduced.matches?'instant':'smooth'});
  const advance = direction => {
   const step = (cards[0]?.getBoundingClientRect().width || track.clientWidth)+(parseFloat(getComputedStyle(track).columnGap)||0);
   move(position()+direction*step);
  };
  prev.addEventListener('click',()=>advance(-1),{signal}); next.addEventListener('click',()=>advance(1),{signal});
  track.addEventListener('scroll',schedule,{signal,passive:true});
  track.addEventListener('keydown',event=>{
   if(event.target!==track)return;
   if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();advance((event.key==='ArrowRight'?1:-1)*(rtl?-1:1));}
   if(event.key==='Home'||event.key==='End'){event.preventDefault();move(event.key==='Home'?0:maximum());}
  },{signal});
  this.resizeObserver = new ResizeObserver(schedule); this.resizeObserver.observe(track); cards.forEach(card=>this.resizeObserver.observe(card)); update();
 }
 disconnectedCallback(){this.controller?.abort();this.controller=null;this.resizeObserver?.disconnect();cancelAnimationFrame(this.frame);this.frame=0;}
});


  } catch(e) { console.error(e); }
})();
})();
